import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";
import { hideLoader, showLoader } from "./loaderSlice";

export const fetchAnalytics = createAsyncThunk(
  "dashboard/analytics",
  async () => {
    const response = await api("get", endPoints.DASHBOARD_ANALYTICS);
    return response.data;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    analytics: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.analytics = action.payload;
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      });
  },
});

export default dashboardSlice.reducer;
